import { render, staticRenderFns } from "./ProgressCard.vue?vue&type=template&id=651009c4&scoped=true&lang=pug&"
import script from "./ProgressCard.vue?vue&type=script&lang=js&"
export * from "./ProgressCard.vue?vue&type=script&lang=js&"
import style0 from "./ProgressCard.vue?vue&type=style&index=0&id=651009c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651009c4",
  null
  
)

export default component.exports